import {createPortal} from 'react-dom';

export function DocumentPortal ({children}) {
  return createPortal(children, document.body);
}
